$ = require 'jquery'
Announcement = require 'models/announcement'
Auth = require 'db/auth'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
f = require 'effing'

module.exports = class AnnouncementsList extends CollectionWithHelpers
  constructor: (list, { @requiresLogin, @dataUrl }) ->
    super

  model: Announcement
  sync: (method, list, options) ->
    if @requiresLogin && !Auth.isLoggedIn()
      return
    $.ajax
      url: @dataUrl
      success: (response) ->
        options.success?(list, response, options)
    return

  forLocale: (locale) -> @filter f.method('matchesLocale', locale)



// WEBPACK FOOTER //
// ./app/scripts/models/collections/announcements-list.coffee